module.exports = __webpack_public_path__ + "img/img48.088c0e4f.webp";